import { makeAsyncComponent } from 'page-lib/utils/makeAsyncUtils';
export default makeAsyncComponent(() => import( /* webpackChunkName: "chunk-column-switcher" */'./VariationsTableColumnSwitcherModal'));